// 小区管理相关API接口
import request from '@/utils/request'
// 向外按需导出一个API函数
/**
 *获取所有省份
 * @param data
 * @returns {*}
 */
export function getProvince() {
    return request({
        url: '/region/province',
        method: 'get'
    })
}

/**
 * 根据省份code获取市
 * @param code 省代码
 */
export function getCity(code) {
    return request({
        url: '/region/province/' + code + '/cities',
        method: 'get'
    })
}

/**
 *
 * @param code
 * @returns {*}
 */
export function getArea(code) {
    return request({
        url: '/region/city/' + code + '/areas',
        method: 'get'
    })
}

/**
 * 根据条件获取社区列表
 * @param data
 * @returns {*}
 */
export function getCommunity(params) {
    return request({
        url: '/region/community/list',
        method: 'post',
        params
    })
}

/**
 * 获取小区分页信息
 * @param params
 * @param data
 * @returns {*}
 */
export function getCommunityPage(params,data) {
    return request({
        url: '/region/community/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 修改小区名称
 * @param data
 * @returns {*}
 */
export function updateCommunity(data) {
    return request({
        url: '/region/community',
        method: 'put',
        data
    })
}

/**
 * 添加小区
 * @param data
 * @returns {*}
 */
export function addCommunity(data) {
    return request({
        url: '/region/community',
        method: 'post',
        data
    })
}
